import { useEffect, useState } from 'react'
import { useChallenge } from '../challenge/useChallenge'
import { useChallengeId } from '../challenge/useChallengeId'
import { useChallengeTheme } from '../challenge/useChallengeTheme'
import { readThemeColor } from '../../ui/theme/readThemeColor'

export function useThemeColors(variables: readonly string[]): string[] {
  const theme = useChallengeTheme()
  const challengeId = useChallengeId()
  const { data: challenge } = useChallenge(challengeId)
  const [colors, setColors] = useState(() => variables.map(readThemeColor))
  const variableKey = variables.join('\0')

  useEffect(() => {
    setColors(variables.map(readThemeColor))
  }, [theme, challenge?.primaryColor, challenge?.secondaryColor, variableKey, variables])

  return colors
}
